module.exports = __webpack_public_path__ + "static/media/gefiswiss.098f7c3d.png";